var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_37993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7663 12.5534C23.7663 11.7376 23.7001 10.9175 23.559 10.115H12.2402V14.736H18.722C18.453 16.2263 17.5888 17.5447 16.3233 18.3825V21.3808H20.1903C22.4611 19.2908 23.7663 16.2043 23.7663 12.5534Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2391 24.2777C15.4756 24.2777 18.205 23.215 20.1936 21.3807L16.3266 18.3824C15.2507 19.1144 13.8618 19.5288 12.2435 19.5288C9.11291 19.5288 6.45849 17.4168 5.50607 14.5771H1.51562V17.6681C3.55274 21.7203 7.70192 24.2777 12.2391 24.2777Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50277 14.5771C5.00011 13.0867 5.00011 11.4729 5.50277 9.98254V6.8916H1.51674C-0.185266 10.2824 -0.185266 14.2772 1.51674 17.668L5.50277 14.5771Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2391 5.02652C13.9499 5.00006 15.6034 5.64382 16.8425 6.82552L20.2685 3.39947C18.0991 1.36236 15.2198 0.242389 12.2391 0.277664C7.70192 0.277664 3.55274 2.83508 1.51562 6.89166L5.50166 9.98261C6.44967 7.13859 9.1085 5.02652 12.2391 5.02652Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_37993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.276855)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.610508ac59f307ff1f2f21dcb7b981d3.svg";
export { ForwardRef as ReactComponent };